function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "gift-solid",
  d: "M1.143,46.857A1.142,1.142,0,0,0,2.286,48H8V42.286H1.143ZM10.286,48H16a1.142,1.142,0,0,0,1.143-1.143V42.286H10.286Zm6.857-11.429h-1.5A3.114,3.114,0,0,0,16,35.143,3.147,3.147,0,0,0,12.857,32c-1.486,0-2.446.761-3.679,2.439C7.946,32.761,6.986,32,5.5,32a3.147,3.147,0,0,0-3.143,3.143,3.07,3.07,0,0,0,.361,1.429H1.143A1.142,1.142,0,0,0,0,37.714v2.857a.573.573,0,0,0,.571.571H17.714a.573.573,0,0,0,.571-.571V37.714A1.142,1.142,0,0,0,17.143,36.571Zm-11.646,0a1.429,1.429,0,0,1,0-2.857c.711,0,1.236.118,3.075,2.857Zm7.361,0H9.782c1.836-2.732,2.346-2.857,3.075-2.857a1.429,1.429,0,1,1,0,2.857Z",
  transform: "translate(0 -32)",
  fill: "#333"
});

function SvgGiftSolid(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.286,
    height: 16,
    viewBox: "0 0 18.286 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGiftSolid);
export default __webpack_public_path__ + "static/media/gift-solid.d8fb54e5.svg";
export { ForwardRef as ReactComponent };